// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"tweetSection_sectionWrapper__rjxMG","replyInput":"tweetSection_replyInput__O1oyM"};